export default __webpack_public_path__ + "static/media/resources-and-production-4.e88da1fc.png";